var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',{staticClass:"f-20 f-m-14 margin-0"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_c('p',{staticClass:"f-14 f-m-12 c-grey margin-0"},[_vm._v("Silahkan lengkapi data "+_vm._s(_vm.note)+" dibawah ini")]),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }